import { getApiToken } from '../../webmodule-common/other/api/current-user';
import { ILicenseServerApiCredentials } from '../common/licenseserver-integration';

export function getCredentials(): ILicenseServerApiCredentials {
  return {
    host: globalThis.dealerConfiguration.licenseServerHost,
    token: getApiToken()
  };
}
